function cov_25rny72ksi() {
  var path = "/app/src/components/trust-banner/index.ts";
  var hash = "047a9d1403e6e10909f26e05104201d0f7be40f0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/trust-banner/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "047a9d1403e6e10909f26e05104201d0f7be40f0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_25rny72ksi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_25rny72ksi();
export { TrustBanner } from './trust-banner';